module.exports = __webpack_public_path__ + "static/img/huangguan.292a61cc.png";